import { EXPORT_PRESETS, ExportPreset } from '../types';

interface ExportPresetsProps {
  activePreset: string | null;
  onApply: (preset: ExportPreset) => void;
}

export default function ExportPresets({ activePreset, onApply }: ExportPresetsProps) {
  return (
    <div className="mb-6">
      <div className="flex items-center gap-2 mb-3">
        <span className="text-xs font-semibold tracking-widest text-stone-500 uppercase">Quick Presets</span>
        <span className="text-xs text-stone-600 bg-stone-800/60 px-2 py-0.5 rounded-full">Configure in one click</span>
      </div>
      <div className="flex flex-wrap gap-2">
        {EXPORT_PRESETS.map((preset) => {
          const isActive = activePreset === preset.id;
          return (
            <button
              key={preset.id}
              onClick={() => onApply(preset)}
              className={`flex items-center gap-2 px-3.5 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap border ${
                isActive
                  ? 'bg-orange-500 border-orange-500 text-white'
                  : 'bg-stone-900 border-stone-700 text-stone-300 hover:border-orange-500/50 hover:text-orange-400'
              }`}
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`${preset.icon} text-sm`} />
              </div>
              {preset.label}
              {isActive && (
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line text-sm" />
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
